import { render, staticRenderFns } from "./RestoreStudentDialog.vue?vue&type=template&id=afc1a1ea&scoped=true"
import script from "./RestoreStudentDialog.vue?vue&type=script&lang=js"
export * from "./RestoreStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./RestoreStudentDialog.vue?vue&type=style&index=0&id=afc1a1ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc1a1ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc1a1ea')) {
      api.createRecord('afc1a1ea', component.options)
    } else {
      api.reload('afc1a1ea', component.options)
    }
    module.hot.accept("./RestoreStudentDialog.vue?vue&type=template&id=afc1a1ea&scoped=true", function () {
      api.rerender('afc1a1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupout/RestoreStudentDialog.vue"
export default component.exports